import { render, staticRenderFns } from "./datetime.vue?vue&type=template&id=d6579954&scoped=true&"
import script from "./datetime.vue?vue&type=script&lang=js&"
export * from "./datetime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6579954",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6579954')) {
      api.createRecord('d6579954', component.options)
    } else {
      api.reload('d6579954', component.options)
    }
    module.hot.accept("./datetime.vue?vue&type=template&id=d6579954&scoped=true&", function () {
      api.rerender('d6579954', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/input/datetime.vue"
export default component.exports